import React, { useState } from 'react';
import './App.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Header from './components/Header';
import Hero from './components/Hero';
import CostOfBadHires from './components/CostOfBadHires';
import ValueProposition from './components/ValueProposition';
import YuZuMethod from './components/YuZuMethod';
import Services from './components/Services';
import Differentiation from './components/Differentiation';
import Insights from './components/Insights';
import Founder from './components/Founder';
import FAQ from './components/FAQ';
import MeetFounders from './components/MeetFounders';
import FinalCTA from './components/FinalCTA';
import Footer from './components/Footer';
import PrivacyPolicy from './components/PrivacyPolicy';
import TermsOfService from './components/TermsOfService';
import VacanciesPage from './components/VacanciesPage';
import ConsultationModal from './components/ConsultationModal';
import { Toaster } from './components/ui/sonner';

const HomePage = ({ onConsultationClick, onVacancyClick }) => {
  return (
    <>
      <Header onConsultationClick={onConsultationClick} />
      <Hero 
        onConsultationClick={onConsultationClick}
        onVacancyClick={onVacancyClick}
      />
      <CostOfBadHires onConsultationClick={onConsultationClick} />
      <ValueProposition />
      <YuZuMethod />
      <Services onConsultationClick={onConsultationClick} />
      <Differentiation />
      <Insights />
      <Founder />
      <FAQ />
      <MeetFounders />
      <FinalCTA onConsultationClick={onConsultationClick} />
      <Footer />
    </>
  );
};

function App() {
  const [isConsultationModalOpen, setIsConsultationModalOpen] = useState(false);
  const [isVacancyModalOpen, setIsVacancyModalOpen] = useState(false);

  return (
    <BrowserRouter>
      <div className="App">
        <Routes>
          <Route 
            path="/" 
            element={
              <HomePage 
                onConsultationClick={() => setIsConsultationModalOpen(true)}
                onVacancyClick={() => setIsVacancyModalOpen(true)}
              />
            } 
          />
          <Route 
            path="/vacancies" 
            element={
              <VacanciesPage 
                onConsultationClick={() => setIsConsultationModalOpen(true)}
                onVacancyClick={() => setIsVacancyModalOpen(true)}
              />
            } 
          />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/terms-of-service" element={<TermsOfService />} />
        </Routes>

        <ConsultationModal 
          isOpen={isConsultationModalOpen}
          onClose={() => setIsConsultationModalOpen(false)}
          type="consultation"
        />

        <ConsultationModal 
          isOpen={isVacancyModalOpen}
          onClose={() => setIsVacancyModalOpen(false)}
          type="vacancy"
        />

        <Toaster />
      </div>
    </BrowserRouter>
  );
}

export default App;
